import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@byte-design/ui';
import { CloseSmall } from '@byte-design/icons';
import { IModal } from '@byte-design/ui/lib/components/modal/Modal';
import { observer } from 'mobx-react';
import styles from './index.module.scss';

export interface ConfirmModalProps extends IModal {
  className?: string;
  headerTitle?: string;
  children?: React.ReactNode;
}
const ConfirmModal = (props: ConfirmModalProps) => {
  const { t } = useTranslation();
  const { headerTitle, children, ...rest } = props;

  const Header = (
    <div className={styles.header}>
      <h2 className={styles.headerTitle}>{t(headerTitle!)}</h2>
      <CloseSmall
        className={styles.closeIcon}
        size="32"
        fill="rgba(22, 24, 35, 0.75)"
        onClick={() => rest?.onCancel?.()}
      />
    </div>
  );

  return (
    <>
      <Modal.Confirm
        size="sm"
        okText={t('modal_bottom_confirm')}
        cancelText={t('modal_bottom_cancel')}
        className={styles.assignConfirm}
        width={480}
        header={Header}
        closeable={false}
        maskClosable={false}
        {...rest}
      >
        {children}
      </Modal.Confirm>
    </>
  );
};
export default observer(ConfirmModal);
